// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://tjgwwfjqhoykxdfejsve.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRqZ3d3ZmpxaG95a3hkZmVqc3ZlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI3Njg0NzQsImV4cCI6MjA2ODM0NDQ3NH0.lr3-KOBS_RUjQewTHaYiPswn5cY7quHYNJWjR3P9bLo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});